import { Radio } from 'antd';
import styled from 'styled-components';

export default styled(Radio)`
	// Add your styles here
`;
